import React from "react";
import { useInView } from "react-intersection-observer";
import Reveal from "react-awesome-reveal";
import "./Education.scss";
import EducationCard from "./EducationCard";
import { educationInfo } from "../../portfolio";

export default function Education() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  if (educationInfo.display) {
    return (
      <div ref={ref}>
        <Reveal effect="fade" when={inView} triggerOnce={true}>
          <section className="education section" id="education">
            <div className="education-section container" id="education">
              <h2 className="education-heading">Education</h2>
              <div className="education-card-container">
                {educationInfo.schools.map((school, index) => (
                  <EducationCard key={index} school={school} />
                ))}
              </div>
            </div>
          </section>
        </Reveal>
      </div>
    );
  }
  return null;
}
